import Constant from '../common/Constant';

function migrateUserV1(user) {
  if (user.settings) {
    if (!user.settings.alertIncrementMinutes) {
      user.settings.alertIncrementMinutes =
        Constant.DEFAULT_ALERT_INCREMENT_MINUTES;
    }

    if (!user.settings.defaultCurrency) {
      user.settings.defaultCurrency = Constant.DEFAULT_CURRENCY_CODE;
    }

    if (!user.settings.alertPausedDate) {
      user.settings.alertPausedDate = '';
    }
  }

  if (!user.activity) {
    user.activity = {
      lastActiveProjects: [],
    };
  }

  if (!user.activity.lastActiveProjects) {
    user.activity.lastActiveProjects = [];
  }

  if (!user.timer) {
    user.timer = {
      status: Constant.TIMER_NOT_RUNNING,
      projectId: '',
      startAtMillis: 0,
      millisRecorded: 0,
    };
  }
}

export function migrateUser(user) {
  migrateUserV1(user);
}

function migrateProjectV1(project) {
  let migrated = false;
  if (!project.currencyCode) {
    project.currencyCode = Constant.DEFAULT_CURRENCY_CODE;
    migrated = true;
  }
  return migrated;
}

export function migrateProject(project) {
  return migrateProjectV1(project);
}

function migrateWorkLogV1(workLog) {
  let migrated = false;
  if (!workLog.totalLoggedMillis) {
    workLog.totalLoggedMillis = workLog.totalLoggedHours * 60 * 60 * 1000;
    migrated = true;
  }

  if (!workLog.projectId && workLog.project) {
    workLog.projectId = workLog.project.id;
    migrated = true;
  }
  return migrated;
}

export function migrateWorkLog(workLog) {
  return migrateWorkLogV1(workLog);
}



// WEBPACK FOOTER //
// ./src/migrations/migrationHelper.js